module.exports = __webpack_public_path__ + "static/img/logo.abe5568f.png";